import React from 'react';
import AdminPageTemplate from './template/admin-page';
import SearchMetricsPrompt from './../ui/prompt/admin/search-metrics';
import theme from './../ui/theme';
import { NavLink } from 'react-router-dom';

const AdminSearchMetricsPage = () =>
    <AdminPageTemplate>
        <h2 style={{
            ...theme.getGeneralTextStyle(theme)
        }}>
            Metrics
        </h2>
        <div>
            <NavLink to="/admin/metrics/summary">
                Summary
            </NavLink>
            <span>
                |
            </span>
            <NavLink to="/admin/metrics/graph">
                Graph
            </NavLink>
        </div>
        <SearchMetricsPrompt />
    </AdminPageTemplate>

export default AdminSearchMetricsPage;
